import * as React from "react";
import { makeStyles, Text, Link, Image } from "@fluentui/react-components";
import { flexColumn, centered } from "../../styles/GlobalStyles";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    flexColumn,
    centered,
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
    ul: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    }
});

export const Id = "b3d643f4-44e8-43f4-811c-0b56664ff256";
export const Title = "How to use Ianus Guard inside Flows?";
export const Subtitle = "Explanation on how to use Ianus Guard inside Flows";
export const Description = "Find out how to use Ianus Guard inside Flows and what to take care of";
export const Keywords = ["developer", "lowcode", "nocode", "flow"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <>
            <div className={styles.container}>
                <CardSection title="Prerequisites">
                    <Text>
                        PowerAutomate flows can easily be secured by Ianus Guard. This is done using a custom API and is described below.
                        Be sure to have imported our Ianus Guard solution, preferably via <Link href="https://marketplace.microsoft.com/en-us/product/saas/ianuasoftware.ianus_guard?tab=overview">Microsoft AppSource</Link> or alternatively from <Link href="https://github.com/Ianua-Software/Ianus-Clients/blob/main/solutions/IanusGuard_managed.zip" target="_blank">
                            GitHub
                        </Link> into your organization before starting.
                    </Text>
                </CardSection>

                <CardSection title="Important!">
                    <Text>
                        Ianus Guard can only securely protect your component when importing it managed into your customer's environment.
                        You also have to be extra careful to set the component protected by Ianus Guard, such as your PowerAutomate Flow to not allow customizations inside the managed properties.
                        Otherwise customers could edit your flow and just throw out your Ianus Guard call.
                        <br />
                        <br />
                        Here is how to set this managed property:
                        <br />
                        In your solution, click on the three dots next to its name, selected "Advanced" and then "Managed properties":
                        <br />
                        <br />
                        <Image
                            className={styles.centered}
                            alt="Open managed properties"
                            width="75%"
                            src="/assets/knowledgearticle/open-managed-properties.png"
                        />
                        <br />
                        <br />
                        In the sidepane that opens, make sure to switch the toggle off, so that no customization is possible in target environments:
                        <Image
                            className={styles.centered}
                            alt="Disable allow customizations"
                            width="75%"
                            src="/assets/knowledgearticle/allow-customizations-disabled.png"
                        />
                        <br />
                        <br />
                        Beware, this setting only applies when your component protected this way is imported in the customer's environment as managed.
                        If this is the case, your component is successfully secured and the check can not be removed by the customer.
                    </Text>
                </CardSection>

                <CardSection title="Validate via custom API">
                    <Text>
                        For validating licenses inside flows, you call the custom API ian_IanusLicenseValidation, passing the following parameters:
                        <ul className={styles.ul}>
                            <li><b>publisherId</b>: ExternalId found on your publisher form</li>
                            <li><b>productId</b>: ExternalId found on your product form</li>
                            <li><b>publicKeys</b>: Found on your product form as "Public Key" inside "Product Versions"</li>
                        </ul>
                        As a rule of thumb, all information that you need to enter has a "Copy Button" next to it.
                        <br/>
                        If the response "IsValid" property does not equal true, there is no valid license and you should set this flow execution to failed and abort.
                        This can look similar to this:
                        <br />
                        <br />
                        <Image
                            className={styles.centered}
                            alt="Ianus Guard Flow"
                            width="75%"
                            src="/assets/knowledgearticle/ianus-flow.png"
                        />
                    </Text>
                </CardSection>
            </div>
        </>
    );    
});